import React, { FC } from 'react';
import { SkeletonBodyText } from '../elements';
import UpsellListItem from '../OfferBody/grid/UpsellListItem';

const SkeletonBodyTextGrid: FC = () => (
  <SkeletonBodyText
    containerClassName="skeleton-bodytext-container-grid"
    contentClassName="skeleton-bodytext-content-grid"
  />
);

const SkeletonOfferGrid: FC = () => (
  <UpsellListItem>
    <div className="upsell-list-item-left-section-grid">
      <div className="upsell-list-item-skeleton-image-grid" />
    </div>
    <div>
      <SkeletonBodyTextGrid />
      <SkeletonBodyTextGrid />
      <SkeletonBodyTextGrid />
    </div>
  </UpsellListItem>
);

export default SkeletonOfferGrid;
